import { IssueType } from '../@types/issueType';

export const getIssuePageContent = (type: IssueType) => {
  const issuePageContentMap = {
    [IssueType.NOT_FOUND]: {
      title: 'issuePage.headline',
      message: 'issuePage.not_found.message',
      link: 'issuePage.not_found.link',
    },
    [IssueType.UNKNOWN]: {
      title: 'issuePage.headline',
      message: 'issuePage.unknown.message',
      link: 'issuePage.unknown.link',
    },
    [IssueType.BENEFIT_PAGE_ERROR]: {
      title: 'issuePage.headline',
      message: 'issuePage.benefit_page_error.message',
      link: null,
    },
  };
  return issuePageContentMap[type];
};
